import React, { useEffect, useState, useContext } from "react";
import { Context } from "../context";
import { getDataById, getMetadata, getMetadataWithOrder, getTime } from './utils';
import uniqid from "uniqid";
import { MetadataMore } from "./MetadataMore";
import "react-scrubber/lib/scrubber.css";
import { Scrubber } from "react-scrubber";
import { MetadataCommentsLine } from "./MetadataComments";
import styled, { css } from "styled-components";
import { ScrubberLine } from "./ScrubberLine";

import { Slider } from "./Slider";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { MetadataAddTagForm } from "./MetadataAddTagForm";
import { UIscrubber } from '../uikit/UIscrubber';

export const MetadataSection = React.memo(
  ({
    videoId,
    typeRef,
    typeTitle,
    history,
    match,
    location,
    frame,
    handleFrame,
  }) => {
    const context = useContext(Context);

    const [frameLocal, setFrameLocal] = useState(frame);

    const [viewType, setViewType] = useState("slider"); //slider/line;


    const [taggingInProgress, setTaggingInProgress] = useState(false); //slider/line;

    useEffect(() => {
      // console.log("videoId = ", videoId);
      // debugger
      handleFrame(0);
    }, [videoId]);


    const videoData = getDataById(context, 'videos', videoId)



    // console.log("typeRef = ", typeRef);
    let typeData = getDataById(context, "metaDataTypes", typeRef) || {};
    // console.log("typeData = ", typeData);


    const color = typeData['color'] || '#06a19a';


    const [shown, setShown] = useState();

    return (
      <div className="l_comments_section">
        <div className="l_comments_container">


          <div className="x_meta_sticky"
            style={{ color: color }}
          >
            <div
              className="x_meta_title0"
              // style={{ color: color }}
            >
              <div
                className="x_meta_tag x_meta_tag--title"
                style={{ color: color }}
              >
                <div className="x_meta_icon">
                  <div>
                    <div className="p_player_emoji">{typeData["emoji"]}</div>
                  </div>
                </div>


                <div className="x_meta_title">
                  {Boolean(typeData["title"])
                    ? typeData["title"]
                    : "Highlights"}
                  <div className="x_meta_title_nums0">
                    <div className="x_meta_title_num">
                      {getMetadata(context, videoId, typeRef).length}
                    </div>
                  </div>
                  {/* <div className="x_meta_title_num x_meta_title_num--comments">
                    <div className="x_meta_comment_icon">
                      <div>comment</div>
                    </div>
                    <div>3</div>
                  </div> */}
                </div>

                {/* If there are no tags, the button is hidden */}
                {Boolean(getMetadata(context, videoId, typeRef).length) && <ShowAddTagButton
                  frame={frame}
                  length={videoData['length']}
                  taggingInProgress={taggingInProgress}
                  setTaggingInProgress={setTaggingInProgress}
                  color={color}
                />}


              </div>

              <div className="x_meta_right">



                {/* //TODO: Switch between Text comments and Slider comments. Saved for later  */}
                {/* <div className="x_meta_menu">
                  <div className="x_select_h">
                    <div
                      className={`x_select_option ${
                        viewType === "slider" ? "active" : ""
                      }`}
                      onClick={() => setViewType("slider")}
                    >
                      <div className="x_meta_comment_icon">
                        <div>burst_mode</div>
                      </div>
                      Timeline
                    </div>

                    <div
                      className={`x_select_option ${
                        viewType === "line" ? " active" : ""
                      }`}
                      onClick={() => setViewType("line")}
                    >
                      <div className="x_meta_comment_icon">
                        <div>comment</div>
                      </div>
                      Comments
                      <div
                        className="x_select_add"
                        onClick={() => setShown(!shown)}
                      >
                        <div>expand</div>
                      </div>
                    </div>
                  </div>
                </div> */}




              </div>
            </div>



            <div className="p_player_scrubber0">




              <ScrubberMarkers
                tagsArray={getMetadata(context, videoId, typeRef)}
                color={color}
                handleFrame={handleFrame}
              />



              <UIscrubber
                frame={frame}
                color={color}
                handleFrame={handleFrame}
                tagging={taggingInProgress || !Boolean(getMetadata(context, videoId, typeRef).length)}
                handleClick={setTaggingInProgress}
              />






            </div>


            {(taggingInProgress || !getMetadata(context, videoId, typeRef).length)
                && <MetadataAddTagForm
                  typeData={typeData}
                  time={getTime(frame, videoData['length'])}
                  shownByDefault={!getMetadata(context, videoId, typeRef).length}
              handleTag={() => setTaggingInProgress(false)}
              handleClose={getMetadata(context, videoId, typeRef).length
                ? () => setTaggingInProgress(false)
                : null
              }
                />}

          </div>



          <div className="c_player_scrub">





            <div className="c_player_container">
              <div
                className={`p_comments0 p_comments0--collapsible ${
                  !shown || viewType === 'slider' ? "" : "shown"
                }`}
              >
                {/* {getMetadata(context, videoId, typeRef, true).length > 4 && (
                  <MetadataMore handle={() => setShown(!shown)}>
                    {!shown &&
                      `Show ${
                        getMetadata(context, videoId, typeRef).length - 3
                      } more comments`}
                    {shown && `Hide`}
                  </MetadataMore>
                )} */}

                <div className={`c_player_comment0 ${taggingInProgress ? 'c_player_comment0--fade' : 'c_player_comment0'}`}>
                  {viewType === "slider" && (
                    <div className="p_comments0 p_comments0--slider">
                      <Slider
                        handleClick={(metaTime) => handleFrame(metaTime * 100)}
                        array={getMetadata(context, videoId, typeRef)}
                        activeSlideKey={getMetadataWithOrder(context, videoId, typeRef, frame)}
                      >
                      </Slider>
                    </div>
                  )}

                  {viewType === "line" && (
                    <>
                      <div className="c_player_container">
                        <div
                          className={`p_comments0 p_comments0--collapsible ${
                            shown ? "shown" : ""
                          }`}
                        >
                          {getMetadata(context, videoId, typeRef, true).map(
                            (oneMetadata) => {
                              // console.log("oneMetadata = ", oneMetadata);
                              return (
                                <>
                                  {oneMetadata && (
                                    <>
                                      <MetadataCommentsLine {...oneMetadata} />
                                    </>
                                  )}
                                </>
                              );
                            }
                          )}





                          {/* {getMetadata(context, videoId, typeRef).length > 4 && (
                            <MetadataMore handle={() => setShown(!shown)}>
                              {!shown &&
                                `Show ${
                                  getMetadata(context, videoId, typeRef).length - 3
                                } more comments`}
                              {shown && `Hide`}
                            </MetadataMore>
                          )} */}
                        </div>




                      </div>
                    </>
                  )}
                </div>






              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);


const ShowAddTagButton = ({ frame, color, taggingInProgress, setTaggingInProgress, length }) => {
  return (
    <div className="x_meta_title_add0"
      style={{ color: color }}
      onClick={() => setTaggingInProgress(!taggingInProgress)}
    >
      <div className="x_button x_button--micro">
        <div className="ico">
          {taggingInProgress && <div>close</div>}
          {!taggingInProgress && <div>add</div>}
        </div>
        <div className="x_button_colored_bg" />
      </div>
      {!taggingInProgress && <div className="x_meta_title_add_hint">
        <div>Add tag at
          {/* TODO: Current time */}
          {getTime(frame, length)}
        </div>
      </div>}
    </div>
  )
}


const ScrubberMarkers = ({ color, tagsArray = [], handleFrame }) => {
  return (
    <div className="p_player_scroll_line">
      {tagsArray.map((oneMetadata) => {
        let metaTime = oneMetadata["metaTime"];
        return (
          <div
            key={`metadata_${oneMetadata["id"]}`}
            onClick={() => handleFrame(metaTime * 100)}
            className="p_player_comment0"
            style={{
              marginLeft: `${metaTime * 100 - 2}%`,
            }}
          >
            <div
              className="p_player_comment_glow"
              style={{
                backgroundColor: color,
              }}
            />
            <div
              className="p_player_comment"
              style={{
                backgroundColor: color,
              }}
            ></div>
          </div>
        );
      })}
    </div>
  )
}